const colorPalette = {
  red: '#ff7878',
  blackboard: '#212121',
  chalk: '#F0F0F0',
  darkGreen: '#00C974',
  duskyGray: '#636769',
  darkGray: '#616161',
  darkestGray: '#333333',
  fadedBlack: 'rgba(0,0,0, 0.3)',
  fadedLightGreen: 'rgba(102,255,189, 0.2)',
  gray: '#9E9E9E',
  green: '#00E88F',
  lightGreen: '#66FFBD',
  lightSteelGray: '#CACCCE',
  lightGray: '#E0E0E0',
  transparent: 'rgba(255, 255, 255, 0)',
  vividGreen: '#26FF76',
  white: '#FFFFFF',
  yellow: '#ffdc2b',
};

export default {
  colorPalette,
};
